import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    useEventBasicInformationContext,
    useTicketContext,
} from '../../../../contexts';
import { DiscountType } from '../../../../types';
import { AggregatedDiscountSignals } from '../DiscountSignal';

export const useDiscounts = (): {
    shouldShow: boolean;
    DiscountsComponent?: React.FC;
} => {
    const {
        discount,
        ticketsInfo: { hasEarlyBirdTickets, hasBogoTickets } = {},
    } = useEventBasicInformationContext();

    const { isFetchComplete } = useTicketContext();

    const discountApplied = discount?.percentOff || discount?.amountOff;
    const hasOpenDiscount =
        discount?.discountType === DiscountType.open && discountApplied;

    if (!isFetchComplete) {
        return { shouldShow: false };
    }

    if (!hasEarlyBirdTickets && !hasOpenDiscount && !hasBogoTickets) {
        return { shouldShow: false };
    }

    const discountsToShow: string[] = [];

    if (hasOpenDiscount) {
        discountsToShow.push(
            gettext('%(discountApplied)s off applied', {
                discountApplied,
            }).toString(),
        );
    }
    if (hasEarlyBirdTickets) {
        discountsToShow.push(gettext('Early bird discount').toString());
    }
    if (hasBogoTickets) {
        discountsToShow.push(gettext('2 for 1 deal').toString());
    }

    return {
        shouldShow: true,
        DiscountsComponent: () => (
            <AggregatedDiscountSignals discounts={discountsToShow} />
        ),
    };
};
